import React, { Suspense, lazy } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import AddStrategy from "./Pages/AddStrategy/Index";
import Login from "./Pages/Login/Login";
import Dashboard from "./Pages/Dashboard/Index";
import Custodians from "./Pages/Custodians/Index";
import Strategy from "./Pages/Strategy/Index";
import Rebalancing from "./Pages/Rebalancing/Index";
import InvestorManagement from "./Pages/InvestorManagement/Index";
import EditStrategy from "./Pages/EditStrategy/Index";
import AccountScreen from "./Pages/Accounting/Index";
import StrategyPerformance from "./Pages/StrategyPerfromance/Index";
import PrivateRoute from "./PrivateRoute";
import RebalancingOrders from "./Pages/RebalancingOrder";
import Order from "./Pages/Orders";
import ActivityLogs from "./Pages/ActivityLogs/index";
import AllNotification from "./Pages/AllNotifications";
import ProfileSettings from "./Pages/ProfileSettings";
import ManagerSettings from "./Pages/ManagerSettings";
import Requests from "./Pages/Requests";
import Accounts from "./Pages/Accounts";
import SelectAccount from "./Pages/SelectAccount/Index";
import SupportContact from "./Pages/SupportContact";

// Lazy load ForgotPassword and CreateAccount components
const ForgotPassword = lazy(() => import("./Pages/ForgotPassword"));
const CreateAccount = lazy(() => import("./Pages/CreateAccount"));

function AllRoutes({ token }) {
  return (
    <Routes>
      {!token ? (
        <>
          <Route path="/login" element={<Login />} />
          <Route 
            path="/forgotpassword" 
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <ForgotPassword />
              </Suspense>
            } 
          />
          <Route 
            path="/createpassword" 
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <CreateAccount />
              </Suspense>
            } 
          />
          <Route path="/supportcontact" element={<SupportContact />} />
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </>
      ) : (
        <>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/selectaccount"
            element={
              <PrivateRoute>
                <SelectAccount />
              </PrivateRoute>
            }
          />
          <Route
            path="/strategy"
            element={
              <PrivateRoute>
                <Strategy />
              </PrivateRoute>
            }
          />
          <Route
            path="/custodians"
            element={
              <PrivateRoute>
                <Custodians />
              </PrivateRoute>
            }
          />
          <Route
            path="/editstrategy/:id"
            element={
              <PrivateRoute>
                <EditStrategy />
              </PrivateRoute>
            }
          />
          <Route
            path="/investor"
            element={
              <PrivateRoute>
                <InvestorManagement />
              </PrivateRoute>
            }
          />
          <Route
            path="/addstrategy"
            element={
              <PrivateRoute>
                <AddStrategy />
              </PrivateRoute>
            }
          />
          <Route
            path="/rebalancing/:id"
            element={
              <PrivateRoute>
                <Rebalancing />
              </PrivateRoute>
            }
          />
          <Route
            path="/performance/:id"
            element={
              <PrivateRoute>
                <StrategyPerformance />
              </PrivateRoute>
            }
          />
          <Route
            path="/accounting"
            element={
              <PrivateRoute>
                <AccountScreen />
              </PrivateRoute>
            }
          />
          <Route
            path="/orders"
            element={
              <PrivateRoute>
                <RebalancingOrders />
              </PrivateRoute>
            }
          />
          <Route
            path="/managerorders"
            element={
              <PrivateRoute>
                <Order />
              </PrivateRoute>
            }
          />
           <Route
                path="/activity"
                element={
                  <PrivateRoute>
                    <ActivityLogs />
                  </PrivateRoute>
                }
              />
               <Route
               path="/allnotification"
               element={
              <PrivateRoute>
                <AllNotification />
              </PrivateRoute>
            }
          />
          <Route path="/settings" element={
             <PrivateRoute>
            <ProfileSettings />
            </PrivateRoute>
            } />
          <Route path="/manager-settings" element={
             <PrivateRoute>
            <ManagerSettings />
            </PrivateRoute>
            } />
          <Route path="/accounts" element={
             <PrivateRoute>
            <Accounts />
            </PrivateRoute>
            } />
          <Route
            path="/requests"
            element={
              <PrivateRoute>
                <Requests />
              </PrivateRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </>
      )}
    </Routes>
  );
}

export default AllRoutes;
